import React from 'react';

import DropdownSearchFetch from '../../../components/Formik/DropdownSearchFetch';

function DropdownPais({ formik, values, names, errors }) {
  let { setFieldValue } = formik;
  return (
    <DropdownSearchFetch
      fluid
      selection
      label="País"
      value={values.Pais}
      onChange={(e, { value }) => {
        setFieldValue(names.Pais, value);
        setFieldValue(names.Colonia, '');
        setFieldValue(names.Estado, '');
      }}
      placeholder="País"
      featherService="catalogo-pais"
      columName="Descripcion"
      columValue="c_Pais"
      mapValues={(value) => {
        return {
          key: Math.random(),
          text: `${value['c_Pais']} - ${value['Descripcion']}`,
          value: value['c_Pais'],
        };
      }}
      error={
        errors.Pais && {
          content: errors.Pais,
        }
      }
    />
  );
}

export default DropdownPais;
